import { render, staticRenderFns } from "./FooterHhgamesVn.vue?vue&type=template&id=05f0df94&scoped=true&"
import script from "./FooterHhgamesVn.vue?vue&type=script&lang=js&"
export * from "./FooterHhgamesVn.vue?vue&type=script&lang=js&"
import style0 from "./FooterHhgamesVn.vue?vue&type=style&index=0&id=05f0df94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0df94",
  null
  
)

component.options.__file = "FooterHhgamesVn.vue"
export default component.exports